import { render, staticRenderFns } from "./AppTabBar.vue?vue&type=template&id=917b9ae6&scoped=true"
import script from "./AppTabBar.vue?vue&type=script&lang=js"
export * from "./AppTabBar.vue?vue&type=script&lang=js"
import style0 from "./AppTabBar.vue?vue&type=style&index=0&id=917b9ae6&prod&lang=scss&scoped=true"
import style1 from "./AppTabBar.vue?vue&type=style&index=1&id=917b9ae6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917b9ae6",
  null
  
)

export default component.exports